import * as React from 'react';
import { Field } from 'react-final-form';
import { Grid } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import TimeOptions from 'scenes/Time/components/TimeOptions';

// Global Form
// @ts-ignore
import RenderDropdown from 'forms/RenderDropdown';
// @ts-ignore
import validators from 'forms/validators';
// @ts-ignore
import normalizers from 'forms/normalizers';

// Validators
const { isRequired } = validators;

// Normalizers
const { toNull } = normalizers;

interface Props {
    endTime?: string;
    startTime?: string;
}

const TimeRangeFields = ({ endTime, startTime }: Props): any => (
    <React.Fragment>
        <Grid.Column width={8}>
            <TimeOptions isStart endTime={endTime}>
                {(options: any): React.ReactElement => (
                    <React.Fragment>
                        <Field
                            component={RenderDropdown as any}
                            name="startTime"
                            subscription={{
                                value: true,
                                touched: true,
                                error: true
                            }}
                            options={options}
                            label="Start Time"
                            placeholder="Enter start time"
                            parse={toNull}
                            fluid
                            search
                            selection
                            clearable
                            selectOnBlur={false}
                            validate={isRequired}
                        />
                    </React.Fragment>
                )}
            </TimeOptions>
        </Grid.Column>
        <Grid.Column width={8}>
            <TimeOptions isEnd startTime={startTime}>
                {(options: any): React.ReactElement => (
                    <Field
                        component={RenderDropdown as any}
                        subscription={{
                            value: true,
                            touched: true,
                            error: true
                        }}
                        options={options}
                        name="endTime"
                        label="End Time"
                        placeholder="Enter end time"
                        parse={toNull}
                        fluid
                        search
                        selection
                        clearable
                        selectOnBlur={false}
                        validate={isRequired}
                    />
                )}
            </TimeOptions>
        </Grid.Column>
    </React.Fragment>
);

export default TimeRangeFields;
